import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import SalesRepsFeedbackBanner from 'components/SalesRepSetupV2/SalesRepsFeedbackBanner'
import SectionHeader from 'components/SectionHeader'
import { TEAMS } from 'constants/sections/teams'
import useLocalStorage from 'hooks/useLocalStorage'
import SalesRepSetup from 'layouts/SalesRepSetup'
import SalesUsageReport from 'layouts/SalesUsageReport'
import { clearConversationFilters } from 'modules/filter/actions'
import {
  userHasSalesUsageReportsFeature,
  userHasTeamUsageDashboardFeature,
} from 'utils/access'

const TeamReport = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(clearConversationFilters())
  }, [dispatch])
  const location = useLocation()
  const [showBanner, setShowBanner] = useLocalStorage<boolean>(
    'SalesRepsSetupFeedbackBannerShow',
    true
  )
  const isSalesSetup = location.pathname.includes('/team/sales-setup')

  return (
    <div className="sales-results-layout">
      {showBanner && isSalesSetup && (
        <SalesRepsFeedbackBanner setShowBanner={setShowBanner} />
      )}
      <SectionHeader {...TEAMS} />
      <Route path="/team">
        <Switch>
          {userHasTeamUsageDashboardFeature() && (
            <Route
              path="/team/sales-setup"
              component={() => <SalesRepSetup />}
            />
          )}

          {userHasSalesUsageReportsFeature() && (
            <Route
              path="/team/sales-usage"
              component={() => <SalesUsageReport />}
            />
          )}
          <Redirect
            from="/team"
            to={{ ...location, pathname: '/availability' }}
          />
        </Switch>
      </Route>
    </div>
  )
}

export default TeamReport
